module.exports = __webpack_public_path__ + "img/dripmerch.70117df5.jpg";